import { useNavigate } from '@share/utils';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ActivitySearchSection } from '@components';
import { Routes } from '@share/constants';
import { GetHomeParams, RootState } from '@share/utils';


const REDIRECT_DELAY_MS = 200;

export function ActivitySearchPage() {
  const navigate = useNavigate();
  const { accountUsername } = useParams<{ accountUsername: string }>();
  const { loading, activities } = useSelector((state: RootState) => state.activityStore);
  const account = useSelector((state: RootState) => state.loginStore?.account);
  const hasRedirectedRef = useRef(false);

  const hasResults = activities != null && Array.isArray(activities);
  const showSearch = loading || hasResults;

  useEffect(() => {
    const timer = setTimeout(() => {
      const shouldRedirect = !loading && !hasResults;
      if (shouldRedirect && !hasRedirectedRef.current) {
        hasRedirectedRef.current = true;
        const homePath = `${accountUsername ? `/${accountUsername}${Routes.Activities}` : Routes.Activities}${GetHomeParams(account)}`;
        navigate(homePath, { replace: true });
      }
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timer);
  }, [loading, activities, navigate, accountUsername, hasResults]);

  return (
    <div className="search-page" style={showSearch ? undefined : { display: 'none' }}>
      <ActivitySearchSection />
    </div>
  );
}
